import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./IngresoAdmin.css";

export default function IngresoAdmin() {
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);

  const cerrarSesion = () => {
    localStorage.removeItem("user");
    navigate("/");
  };

  return (
    <div className="admin-container">

      {/* BOTÓN CERRAR SESIÓN */}
      <button
        className="logout-btn"
        onClick={() => setMostrarConfirmacion(true)}
      >
        🚪 Cerrar sesión
      </button>


      {/* ENCABEZADO */}
      <div className="admin-header">

        <div className="admin-icon">
          ⚙️
        </div>

        <h1 className="admin-title">
          Panel Administrador
        </h1>

        <p className="admin-welcome">
          Bienvenido,{" "}
          <strong>
            {user?.persona_nombre || user?.usuario}
          </strong>
        </p>

      </div>


      {/* OPCIONES */}
      <div className="admin-buttons">

        <button
          className="admin-option"
          onClick={() => navigate("/ListaUsuarios")}
        >
          <span className="option-icon">📋</span>

          <span className="option-text">
            <strong>Lista de usuarios</strong>
            <small>Consultar y administrar usuarios</small>
          </span>

          <span className="option-arrow">›</span>
        </button>


        <button
          className="admin-option"
          onClick={() => navigate("/CrearUsuarios")}
        >
          <span className="option-icon">➕</span>

          <span className="option-text">
            <strong>Crear usuario</strong>
            <small>Registrar un nuevo usuario</small>
          </span>

          <span className="option-arrow">›</span>
        </button>


        <button
          className="admin-option"
          onClick={() => navigate("/configurarusuarios")}
        >
          <span className="option-icon">👥</span>

          <span className="option-text">
            <strong>Configurar supervisores</strong>
            <small>Asignar supervisores a cobradores</small>
          </span>

          <span className="option-arrow">›</span>
        </button>


        <button
          className="admin-option"
          onClick={() => navigate("/principal")}
        >
          <span className="option-icon">📊</span>

          <span className="option-text">
            <strong>Estadísticas</strong>
            <small>Consultar estadísticas del sistema</small>
          </span>

          <span className="option-arrow">›</span>
        </button>


        <button
          className="admin-option"
          onClick={() => navigate("/ver-base-datos")}
        >
          <span className="option-icon">🗄️</span>

          <span className="option-text">
            <strong>Eliminar usuarios</strong>
            <small>Administrar y eliminar usuarios</small>
          </span>

          <span className="option-arrow">›</span>
        </button>

      </div>


      {/* MODAL CONFIRMAR CIERRE DE SESIÓN */}
      {mostrarConfirmacion && (
        <div
          className="logout-overlay"
          onClick={() => setMostrarConfirmacion(false)}
        >

          <div
            className="logout-modal"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="logout-modal-icon">
              🚪
            </div>

            <h2>
              ¿Cerrar sesión?
            </h2>

            <p>
              ¿Estás seguro de que deseas salir de tu cuenta?
            </p>

            <div className="logout-modal-buttons">

              <button
                className="cancelar-btn"
                onClick={() => setMostrarConfirmacion(false)}
              >
                Cancelar
              </button>

              <button
                className="confirmar-salir-btn"
                onClick={cerrarSesion}
              >
                Salir
              </button>

            </div>

          </div>

        </div>
      )}

    </div>
  );
}